import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import TopStrip from "./TopStrip";
import AIAgentModal from "@/components/common/AIAgentModal";
import QuoteDrawer from "@/components/common/QuoteDrawer";
import PartnerDrawer from "@/components/common/PartnerDrawer";
import ProjectEstimateWizard from "@/components/common/ProjectEstimateWizard";

// Note: Global Organization + WebSite + LocalBusiness JSON-LD live in
// /public/index.html so they're picked up by crawlers before React hydrates.
// Per-page schemas (Service, FAQPage, BreadcrumbList) are injected via
// react-helmet-async in Seo.jsx and FaqSection.jsx.

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);

  const isAdmin = pathname.startsWith("/admin");
  const isHome = pathname === "/";

  return (
    <div className="relative min-h-screen bg-background text-foreground overflow-x-clip">
      {!isAdmin && <TopStrip />}
      {!isAdmin && <Navbar />}
      <main className={(isAdmin ? "" : isHome ? "" : "pt-32") + " overflow-x-clip"}>
        <Outlet />
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <AIAgentModal />}
      {!isAdmin && <QuoteDrawer />}
      {!isAdmin && <PartnerDrawer />}
      {!isAdmin && <ProjectEstimateWizard />}
    </div>
  );
}
